"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InputHelper_1 = require("./InputHelper");
var InternalInput_1 = require("./InternalInput");
var util_1 = require("../../../utils/util");
/**
 * OUI text area component.
 *
 * @oui-component TextArea
 */
var Textarea = function (_a) {
    var value = _a.value, defaultValue = _a.defaultValue, fieldName = _a.fieldName, onChange = _a.onChange, onBlur = _a.onBlur, placeholder = _a.placeholder, testId = _a.testId, resize = _a.resize, disabled = _a.disabled, rest = __rest(_a, ["value", "defaultValue", "fieldName", "onChange", "onBlur", "placeholder", "testId", "resize", "disabled"]);
    var styleProps = resize && { resize: resize };
    return (React.createElement(InputHelper_1.default, { disabled: disabled, value: value, defaultValue: defaultValue, fieldName: fieldName, onBlur: onBlur, onChange: onChange, mapFormValue: InputHelper_1.mapEventTargetValue }, function (helper) {
        var describedBy = [helper.hintId, helper.errorId].join(" ").trim();
        var props = __assign({}, rest, util_1.ariaProps({ describedBy: describedBy }), { disabled: disabled,
            placeholder: placeholder, from: "textarea", style: styleProps, className: "oui-textarea", name: helper.fieldName, id: helper.fieldId, value: helper.value || "", onChange: helper.onChange, onBlur: helper.onBlur, "data-test-id": testId });
        return React.createElement(InternalInput_1.default, __assign({}, props));
    }));
};
exports.default = Textarea;
//# sourceMappingURL=Textarea.js.map